import { ClerkApp } from "@clerk/remix";
import { rootAuthLoader } from "@clerk/remix/ssr.server";
import { cssBundleHref } from "@remix-run/css-bundle";
import type { LinksFunction, LoaderFunction } from "@remix-run/node";
import { Links, LiveReload, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData } from "@remix-run/react";
import reactflowCss from "reactflow/dist/style.css";
import { ClientOnly } from "remix-utils/client-only";

import { AnalyticsProvider, PageViewTracker } from "~/analytics/index.client";
import common from "~/common.css";
import config from "~/config.server";
import fonts from "~/fonts.css";
import { normalizeDashboardRequestArgs } from "~/utils/auth.server";

import stylesheet from "./tailwind.css";

export const links: LinksFunction = () => [
{ rel: "stylesheet", href: stylesheet },
{ rel: "preconnect", href: "https://rsms.me/" },
{ rel: "stylesheet", href: "https://rsms.me/inter/inter.css" },
{ rel: "stylesheet", href: fonts },
{ rel: "stylesheet", href: reactflowCss },
{ rel: "stylesheet", href: common },
...(cssBundleHref ? [{ rel: "stylesheet", href: cssBundleHref }] : [])];


export const loader: LoaderFunction = async (args) => {
  const ENV = {
    API_HOST: config.API_HOST,
    RECIPE_ID: config.RECIPE_ID,
    RECOMMENDATIONS_FALLBACK_RECIPE_ID: config.RECOMMENDATIONS_FALLBACK_RECIPE_ID,
    SEARCH_RECOMMENDATIONS_RECIPE_ID: config.SEARCH_RECOMMENDATIONS_RECIPE_ID,
    DASHBOARD_URL: config.DASHBOARD_URL,
    CLERK_OAUTH_DOMAIN: config.CLERK_OAUTH_DOMAIN,
    COMMON_ASSETS_BASE_URL: config.COMMON_ASSETS_BASE_URL,
    COMMON_ASSETS_CONTENT_RESET_URL: config.COMMON_ASSETS_CONTENT_RESET_URL,
    MIXPANEL_TOKEN: config.MIXPANEL_TOKEN,
    ENABLE_VARIANT_DEBUGGER: config.ENABLE_VARIANT_DEBUGGER ? "true" : "false",
    NODE_ENV: config.NODE_ENV
  };

  return rootAuthLoader(normalizeDashboardRequestArgs(args), async () => {
    return { ENV };
  });
};

function App() {
  const data = useLoaderData<typeof loader>();

  return (
    <html lang="en" className="no-scrollbar bg-white ">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="icon" href="/static/favicon.ico" />
        <style data-fullcalendar />
        <Meta />
        <Links />
      </head>
      <body className="h-dvh" data-theme="cavaco">
        <ClientOnly>
          {() =>
          <AnalyticsProvider enabled={data.ENV.NODE_ENV !== "development"}>
              <PageViewTracker />
              <Outlet />
            </AnalyticsProvider>
          }
        </ClientOnly>
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.process = ${JSON.stringify({ env: data.ENV })}`
          }} />
        
        <Scripts />
        <LiveReload />
      </body>
    </html>);

}

export { RootErrorBoundary as ErrorBoundary } from "~/components/error-boundary";
export default ClerkApp(App);